import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { OwnerId } from "@/modules/property-tracks/types";

export const getOwnerIds = async (customerUid: string) => {
  const apiUrl = brandUrl<OwnerId[]>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/owner-ids`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      params: { customerUId: customerUid },
    },
  }) as Promise<{ data: OwnerId[] }>;
};

export const uploadOwnerId = async (formData: FormData) => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/owner-ids`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.POST,
      formData: true,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  });
};

export interface OwnerIdDownloadImage {
  uid: string;
  fileName: string;
  fileUrl: string;
}

export const presignOwnerIdDownload = async (ownerIdUid: string) => {
  const apiUrl = brandUrl<{ data: { images: OwnerIdDownloadImage[] } }>(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/owner-ids/${ownerIdUid}/download`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
    },
  }) as Promise<{ data: { images: OwnerIdDownloadImage[] } }>;
};

export const deleteOwnerId = async (ownerIdUid: string): Promise<any> => {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.PROPERTY_MANAGEMENT_API_URL}/owner-ids/${ownerIdUid}/delete`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.DELETE,
    },
  });
};
